"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var react_1 = __importDefault(require("react"));
var MapBox_1 = __importDefault(require("./MapBox"));
var Map = function (_a) {
    var _b = _a.routes, routes = _b === void 0 ? [] : _b, _c = _a.depots, depots = _c === void 0 ? [] : _c, _d = _a.containers, containers = _d === void 0 ? [] : _d, _e = _a.vehicles, vehicles = _e === void 0 ? [] : _e, _f = _a.inquiries, inquiries = _f === void 0 ? [] : _f, mapBoxProps = _a.mapBoxProps, onContainerClick = _a.onContainerClick, onVehicleClick = _a.onVehicleClick, onRouteClick = _a.onRouteClick, onInquiryClick = _a.onInquiryClick, onDepotClick = _a.onDepotClick;
    var images = [
        {
            "name": "image-container",
            "image": "https://wastehero-prod.s3.eu-central-1.amazonaws.com/manual/map_icon_container.png",
            "external": true
        },
        {
            "name": "image-depot",
            "image": "https://wastehero-prod.s3.eu-central-1.amazonaws.com/manual/map_icon_depot.png",
            "external": true
        },
        {
            "name": "image-wasteStation",
            "image": "https://wastehero-prod.s3.eu-central-1.amazonaws.com/manual/map_icon_waste_station.png",
            "external": true
        }
    ];
    var sources = [];
    if (routes) {
        var routeSource = {
            layers: [
                {
                    data: {
                        id: "lines",
                        type: "line",
                        source: "routes",
                        layout: {
                            "line-join": "round",
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": ["get", "line-color"],
                            "line-width": 3,
                            "line-opacity": 0.75
                        }
                    }
                }
            ],
            sourceId: "routes",
            source: {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: routes.map(function (route) { return ({
                        type: "Feature",
                        properties: {
                            id: route.id,
                            "line-color": "#FF0000"
                        },
                        geometry: {
                            coordinates: (route.locations.map(function (location) { return [location.latitude, location.longitude]; })),
                            type: "LineString"
                        }
                    }); })
                }
            }
        };
        sources.push(routeSource);
    }
    if (containers) {
        var containerSource = {
            layers: [
                {
                    "data": {
                        "id": "containers-cluster",
                        "type": "circle",
                        "source": "containers",
                        "filter": ["has", "point_count"],
                        "paint": {
                            'circle-radius': [
                                'step',
                                ['get', 'point_count'],
                                10,
                                2,
                                15,
                                10,
                                20,
                                99999,
                                30
                            ],
                            "circle-color": "#DF9838",
                            "circle-stroke-color": "#FFFFFF",
                            "circle-stroke-width": 2
                        }
                    },
                    onClick: function (e, map) {
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["containers-cluster"]
                        });
                        // @ts-ignore
                        var clusterId = features[0].properties.cluster_id;
                        // @ts-ignore
                        map.getSource("containers").getClusterExpansionZoom(clusterId, function (err, zoom) {
                            if (err)
                                return;
                            // @ts-ignore
                            var center = features[0].geometry.coordinates;
                            map.easeTo({
                                center: center,
                                zoom: zoom
                            });
                        });
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                },
                {
                    data: {
                        id: "containers-cluster-count",
                        type: "symbol",
                        source: "containers",
                        filter: ["has", "point_count"],
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "text-field": "{point_count_abbreviated}",
                            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                            "text-size": 12
                        },
                        paint: { "text-color": "#FFFFFF" }
                    }
                },
                {
                    data: {
                        id: "containers-unclustered-point",
                        type: "symbol",
                        source: "containers",
                        filter: ["!", ["has", "point_count"]],
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "icon-image": ["get", "icon-image"],
                            "icon-size": 0.50
                        }
                    },
                    onClick: function (e, map) {
                        var _a, _b, _c, _d;
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["containers-unclustered-point"]
                        });
                        // @ts-ignore
                        var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                        map.easeTo({
                            center: center
                        });
                        if (onContainerClick) {
                            onContainerClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                        }
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                }
            ],
            sourceId: "containers",
            source: {
                type: "geojson",
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 25,
                data: {
                    type: "FeatureCollection",
                    features: containers.map(function (container) { return ({
                        type: "Feature",
                        properties: {
                            id: container.id,
                            "icon-image": "image-container"
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [container.location.longitude, container.location.latitude]
                        }
                    }); })
                }
            }
        };
        sources.push(containerSource);
    }
    if (inquiries) {
        var inquirySource = {
            layers: [
                {
                    "data": {
                        "id": "inquiry-cluster",
                        "type": "circle",
                        "source": "inquiries",
                        "filter": ["has", "point_count"],
                        "paint": {
                            "circle-radius": 20,
                            "circle-color": "#123cd4",
                            "circle-stroke-color": "#FFFFFF",
                            "circle-stroke-width": 2
                        }
                    },
                    onClick: function (e, map) {
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["inquiry-cluster"]
                        });
                        // @ts-ignore
                        var clusterId = features[0].properties.cluster_id;
                        // @ts-ignore
                        map.getSource("inquiries").getClusterExpansionZoom(clusterId, function (err, zoom) {
                            if (err)
                                return;
                            // @ts-ignore
                            var center = features[0].geometry.coordinates;
                            map.easeTo({
                                center: center,
                                zoom: zoom
                            });
                        });
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                },
                {
                    data: {
                        id: "inquiries-cluster-count",
                        type: "symbol",
                        source: "inquiries",
                        filter: ["has", "point_count"],
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "text-field": "{point_count_abbreviated}",
                            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                            "text-size": 12
                        },
                        paint: { "text-color": "#FFFFFF" }
                    }
                },
                {
                    data: {
                        id: "inquiries-unclustered-point",
                        type: "symbol",
                        source: "inquiries",
                        filter: ["!", ["has", "point_count"]],
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "icon-image": ["get", "icon-image"],
                            "icon-size": 0.50
                        }
                    },
                    onClick: function (e, map) {
                        var _a, _b, _c, _d;
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["inquiries-unclustered-point"]
                        });
                        // @ts-ignore
                        var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                        map.easeTo({
                            center: center
                        });
                        if (onInquiryClick) {
                            onInquiryClick((_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                        }
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                }
            ],
            sourceId: "inquiries",
            source: {
                type: "geojson",
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 25,
                data: {
                    type: "FeatureCollection",
                    features: inquiries.map(function (inquiry) { return ({
                        type: "Feature",
                        properties: {
                            id: inquiry.id,
                            "icon-image": "image-container"
                        },
                        geometry: {
                            type: "Point",
                            coordinates: ([inquiry.location.longitude, inquiry.location.latitude])
                        }
                    }); })
                }
            }
        };
        sources.push(inquirySource);
    }
    if (depots) {
        var depotSource = {
            layers: [
                {
                    data: {
                        id: "depots",
                        type: "symbol",
                        source: "depots",
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "icon-image": ["get", "image-icon"],
                            "icon-size": 0.50
                        }
                    },
                    onClick: function (e, map) {
                        var _a, _b, _c, _d, _e, _f;
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["depots"]
                        });
                        // @ts-ignore
                        var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                        map.easeTo({
                            center: center
                        });
                        console.log("depotId", (_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                        if (onDepotClick) {
                            onDepotClick((_f = (_e = features[0]) === null || _e === void 0 ? void 0 : _e.properties) === null || _f === void 0 ? void 0 : _f.id);
                        }
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                },
                {
                    data: {
                        id: "depot-text",
                        type: "symbol",
                        source: "depots",
                        layout: {
                            "icon-allow-overlap": true,
                            "text-allow-overlap": true,
                            "text-field": ["get", "name"],
                            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
                            "text-size": 12,
                            'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                            'text-radial-offset': 1,
                            'text-justify': 'auto',
                        },
                        paint: { "text-color": "#000000" }
                    }
                },
            ],
            sourceId: "depots",
            source: {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: depots.map(function (depot) {
                        var imageSrc = "";
                        if (depot.type === "wasteStation") {
                            imageSrc = "image-wasteStation";
                        }
                        else if (depot.type === "depot") {
                            imageSrc = "image-depot";
                        }
                        return {
                            type: "Feature",
                            properties: {
                                id: depot.id,
                                name: depot.name,
                                "image-icon": imageSrc,
                            },
                            geometry: {
                                type: "Point",
                                coordinates: [depot.location.longitude, depot.location.latitude]
                            }
                        };
                    })
                }
            }
        };
        sources.push(depotSource);
    }
    if (vehicles) {
        var vehicleSource = {
            layers: [
                {
                    data: {
                        id: "vehicles",
                        type: "circle",
                        source: "vehicles",
                        paint: {
                            "circle-color": ["get", "circle-color"],
                            "circle-radius": 4,
                            "circle-stroke-width": 1,
                            "circle-stroke-color": "#fff"
                        }
                    },
                    onClick: function (e, map) {
                        var _a, _b, _c, _d, _e, _f;
                        // @ts-ignore
                        var features = map.queryRenderedFeatures(e.point, {
                            layers: ["vehicles"]
                        });
                        // @ts-ignore
                        var center = (_b = (_a = features[0]) === null || _a === void 0 ? void 0 : _a.geometry) === null || _b === void 0 ? void 0 : _b.coordinates;
                        map.easeTo({
                            center: center
                        });
                        console.log("vehicleId", (_d = (_c = features[0]) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.id);
                        if (onVehicleClick) {
                            onVehicleClick((_f = (_e = features[0]) === null || _e === void 0 ? void 0 : _e.properties) === null || _f === void 0 ? void 0 : _f.id);
                        }
                    },
                    onMouseEnter: function (e, map) {
                        map.getCanvas().style.cursor = "pointer";
                    },
                    onMouseLeave: function (e, map) {
                        map.getCanvas().style.cursor = "";
                    }
                }
            ],
            sourceId: "vehicles",
            source: {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: vehicles.map(function (vehicle) { return ({
                        type: "Feature",
                        properties: {
                            id: vehicle.id,
                            "circle-color": "#000000"
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [vehicle.location.longitude, vehicle.location.latitude]
                        }
                    }); })
                }
            }
        };
        sources.push(vehicleSource);
    }
    // @ts-ignore
    return react_1.default.createElement(MapBox_1.default, __assign({}, mapBoxProps, { sources: sources, images: images }));
};
exports.default = Map;
